/* DJ Boer Beats — shop theme behaviour. No dependencies, no build step. */
(function () {
  'use strict';

  /* ---- Mobile nav drawer ---- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-nav-drawer]');

  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      drawer.hidden = open;
    });
  }

  /* ---- Product gallery ---- */
  var gallery = document.querySelector('[data-gallery]');

  if (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');

    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb || !mainImg) return;

      var full = thumb.getAttribute('data-full');
      if (full) {
        mainImg.src = full;
        mainImg.srcset = '';
        mainImg.alt = thumb.getAttribute('data-alt') || mainImg.alt;
      }

      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (el) {
        el.setAttribute('aria-current', String(el === thumb));
      });
    });
  }

  /* ---- Variant picker ----
     Maps the selected option values onto a variant id and keeps price,
     availability and the submit button in sync. */
  var form = document.querySelector('[data-product-form]');
  var dataEl = document.querySelector('[data-variant-json]');
  var variants = null;

  if (dataEl) {
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      variants = null;
    }
  }

  if (form && variants && variants.length) {
    var idInput = form.querySelector('[data-variant-id]');
    var submit = form.querySelector('[data-add-to-cart]');
    var priceEl = document.querySelector('[data-price-target]');
    var money = dataEl.getAttribute('data-money-format') || '${{amount}}';

    /* Shopify's money_format uses one of several placeholders. ZAR shops
       typically use amount_with_comma_separator, so matching only {{amount}}
       would leave the raw format string on screen. */
    function group(intPart, sep) {
      return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }

    function formatMoney(cents) {
      return money.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, token) {
        var decimals = token.indexOf('no_decimals') !== -1 ? 0 : 2;
        var sep = ',';
        var dot = '.';

        if (token.indexOf('comma_separator') !== -1) {
          sep = '.';
          dot = ',';
        } else if (token.indexOf('space_separator') !== -1) {
          sep = ' ';
          dot = ',';
        } else if (token.indexOf('apostrophe_separator') !== -1) {
          sep = "'";
        }

        var value = (cents / 100).toFixed(decimals);
        var parts = value.split('.');
        var out = group(parts[0], sep);
        return decimals ? out + dot + parts[1] : out;
      });
    }

    function selectedValues() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function findVariant(values) {
      return variants.find(function (variant) {
        return values.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      });
    }

    /* Grey out sizes that have no available variant, given the other choices.
       The CSS already styles input:disabled + span; nothing set it before. */
    function markAvailability(values) {
      Array.prototype.forEach.call(
        form.querySelectorAll('[data-option-index]'),
        function (group, index) {
          group.querySelectorAll('input').forEach(function (input) {
            var probe = values.slice();
            probe[index] = input.value;

            var reachable = variants.some(function (variant) {
              if (!variant.available) return false;
              return probe.every(function (value, i) {
                return i === index ? variant.options[i] === input.value : value === null || variant.options[i] === value;
              });
            });

            input.disabled = !reachable;
          });
        }
      );
    }

    function update() {
      var values = selectedValues();
      var variant = findVariant(values);
      markAvailability(values);

      if (!variant) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.getAttribute('data-unavailable') || 'UNAVAILABLE';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? submit.getAttribute('data-add') || 'ADD TO CART'
          : submit.getAttribute('data-soldout') || 'SOLD OUT';
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', update);
    update();
  }

  /* ---- Cart quantity: submit on change instead of needing a button ---- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('change', function (event) {
      if (event.target.matches('[data-cart-qty]')) cartForm.submit();
    });
  }
})();
